<span class="page-filter-dropdown-trigger" #triggerButton>
  <soft-ds-button variant="outline"
                  size="lg"
                  aria-haspopup="dialog"
                  [aria-expanded]="open()"
                  (click)="toggle()">
    @if (icon(); as icon) {
      <ng-template softSlot="leading"><soft-ds-icon [name]="icon" /></ng-template>
    }
    <span class="page-filter-dropdown-label" [attr.title]="fullLabel()">
      <span>{{ title() }}</span>
      @if (value(); as value) {
        <span>: </span><span class="page-filter-dropdown-value">{{ value }}</span>
      }
    </span>
    <ng-template softSlot="trailing">
      <soft-ds-icon [name]="open() ? 'fa-regular fa-chevron-up' : 'fa-regular fa-chevron-down'" />
    </ng-template>
  </soft-ds-button>
</span>

<soft-ds-overlay [(open)]="open"
                 [originElement]="trigger()"
                 [content]="panel"
                 [dividers]="false"
                 [offset]="4" />

<ng-template #panel>
  <div class="page-filter-dropdown-panel" role="dialog" [attr.aria-label]="title()">
    <ng-content />
  </div>
</ng-template>
